<template>
  <section class="hebView">
    <!-- <div class="fioriture"></div>
    <h2>Nos hébergements</h2>
    <div class="fioriture"></div>-->
    <h2 class="titlePage">
      <strong>_</strong>
      Nos hébergements
      <strong>_</strong>
    </h2>

    <p>
      L’Agriculture Bio est une passion, l’accueil en est une autre.
      <br />Rencontres, partage, convivialité, repos, amitié ….
      Autant de mots qui représentent notre motivation à vous accueillir En Lébé !
      <br />Le temps d’un week-end ou pour plusieurs jours, différentes formules s’offrent à vous :
    </p>

    <article class="hebItem">
      <transition name="fade" appear>
        <img src="@/assets/images/grandgite/P1070847.jpg" alt="le gîte - gîte en Lebé" />
      </transition>

      <div class="absoInfos wow leftToRight">
        <h3>Le gîte</h3>
        <p>
          A votre arrivée, un parking privatif vous est réservé, fleuri et ombragé. Il vous conduit directement à cette belle bâtisse, située au cœur de
          notre exploitation agricole bio. Elle permet une capacité de couchage pour 10 ou 17 personnes. De grand confort, elle répondra à vos
          attentes grâce aux prestations que nous mettons à disposition.
        </p>

        <router-link to="nos-hebergements/le-gite" class="greenBtn">Voir plus d'infos</router-link>
      </div>
    </article>

    <article class="hebItem reverseHebItem" id="secondHeb">
      <div class="absoInfos absoInfosLeft wow rightToLeft">
        <h3>Le studio</h3>

        <p>
          Idéal pour un couple, vous êtes complètement autonomes puisqu’il est parfaitement équipé pour cuisiner,
          se reposer, et partir à la découverte des jolis villages voisins, profiter des marchés, arpenter les chemins de randonnée….
          Il y en a pour tous les goûts ! Nous pourrons vous conseiller.
        </p>

        <router-link to="nos-hebergements/studio" class="greenBtn">Voir plus d'infos</router-link>
      </div>

      <transition name="fade" appear>
        <img src="@/assets/images/Studio/Studio A.jpg" alt="le studio - gite en lebé" />
      </transition>
    </article>

    <!-- <article class="hebItem">
      <transition name="fade" appear>
        <img src="@/assets/images/Chambredhote/07.jpg" alt="les chambres d'hotes - gite en lebé" />
      </transition>

      <div class="absoInfos wow leftToRight">
        <h3>
          Les chambres
          <br />d'hôtes
        </h3>
        <p>
          Nos trois chambres d’hôtes vous offrent des
          prestations de qualité : une literie confortable, des sanitaires privatifs, une télévision et un accès wifi…
          avec en prime un petit déjeuner gourmand « fait maison ».
        </p>

        <router-link to="nos-hebergements/chambres-d-hotes" class="greenBtn">Voir plus d'infos</router-link>
      </div>
    </article> -->
    <GreenBarContact></GreenBarContact>
  </section>
</template>

<script>
import WOW from "@/assets/wow.min.js";
import GreenBarContact from "@/components/GreenBarContact.vue";

export default {
  name: "Hebergements",
  data: function () {
    return {
      itemsList: null,
      lastScroll: 0,
      currentView: 0,
      observer: null,
    };
  },
  setup() {},
  created() {
    new WOW(
      { mobile: false } // default
    ).init();
  },
  components: {
    GreenBarContact,
  },

  mounted() {},

  beforeDestroy() {},
  methods: {},
};
</script>
<style>
.hebView {
  text-align: center;
}
.hebView .fioriture {
  height: 70px;
}
.hebView > h2 {
  color: var(--dark-color);
  font-size: 3.5rem;
  margin: 0 0 2rem;
  font-weight: 100;
}
.hebView > p {
  letter-spacing: 0.5px;
  margin-bottom: 3rem;
  font-size: 1.1rem;
}

.presentationItem {
  height: 80vh;
  background: tomato;
}
.barBottom {
  position: relative;
  height: 160px;
}
.barBottom .navImg {
  background: rgba(168, 190, 80, 1);
}
@media all and (max-width: 1000px) {
  .hebItem {
    flex-direction: column;
    width: 100vw;
    border-bottom: 0;
    border-top: 0;
    height: auto;
    margin-bottom: 1rem;
  }
  .hebItem > img {
    width: 100%;
    height: 60vh;
    object-fit: cover;
  }
  .reverseHebItem img {
    margin-left: 0;
  }
  .absoInfos > * {
    margin: 0 2%;
  }
  .greenBtn {
    padding: 0.5rem 1.5rem;
    float: right;
    margin: 1%;
  }
  .reverseHebItem .absoInfosLeft .greenBtn {
    margin-left: 5%;
  }
  .absoInfos .greenBtn {
    margin-left: 5%;
  }
  .absoInfosLeft {
    text-align: left;
  }
  .absoInfos {
    position: relative;
    transform: translateY(0);
    width: 100%;
    border-bottom: 4px solid var(--dark-color);
    padding-bottom: 4px;
    top: unset;
  }

  .reverseHebItem {
    flex-direction: column-reverse;
  }
  .absoInfos h3 {
    margin-bottom: 0;
    width: auto;
    padding: 8px;
    margin-left: 5%;
  }
  .absoInfos p {
    padding: 8px;
    margin-left: 5%;
    width: 90%;
  }
}
@media all and (max-width: 500px) {
  .hebView > h2 {
    font-size: 10vw;
  }

  .hebView p:not(.important) {
    display: none;
  }
  .absoInfos h3 {
    font-size: 10vw;
  }
  .barBottom {
    display: none;
  }
}
</style>